import React, { useState, useEffect } from 'react';

// İKONLAR
import { 
  LayoutDashboard, LogOut, ChevronRight, ChevronLeft, Loader2, Printer, XCircle,  
  CheckCircle, AlertCircle, School, Lock, Brain, X, Check, BarChart2, ShieldCheck,
  Download, Calendar, Users, Settings, Activity, FileText, GraduationCap, Clock, Smartphone, BrainCircuit, 
  BookOpen, Lightbulb, Target, Smile, Wifi, Send, Edit3, Save, Plus, Trash2, CheckSquare, UserMinus,   
  PieChart as PieChartIcon, Zap, TrendingUp, ClipboardList, Briefcase, Megaphone, QrCode, Link, Share2,
  AlertTriangle, HeartPulse, ListTodo, ArrowRight, Stethoscope, ChevronDown, List, Menu, Sparkles, Archive, FolderDown,
  UserPlus, Shield, Star, MailCheck, FolderOpen, CreditCard, Heart, Network, BarChart3, ShieldAlert, Thermometer, Compass, Home, Wallet, Search, Scale, User, FileSpreadsheet, RefreshCw
} from 'lucide-react';

// GRAFİKLER
import { 
  Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, 
  ResponsiveContainer, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid, PieChart, Pie, Cell 
} from 'recharts';
import { QRCodeCanvas } from 'qrcode.react';

// FIREBASE
import { 
  db, auth, saveToCloud, updateInCloud, listenToData, deleteFromCloud, deleteAllFromCloud,   
  registerUser, loginUser, logoutUser, getUserProfile, useCredit as consumeCredit, resetUserPassword 
} from './firebase'; 

import { writeBatch, doc, collection, limit, orderBy, startAfter, onSnapshot, query, where, getDocs, updateDoc } from 'firebase/firestore';
import { onAuthStateChanged, applyActionCode, verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth';

// FORMLAR
import { forms as NEW_FORMS } from './data/forms';


// --- HARİCİ HESAPLAMA MOTORLARI ---
import { calculateHolland } from './utils/Holland_engine';
import { calculateSociometry } from './utils/Sociometry_engine';
import { calculateMeslekiDegerler } from './utils/MeslekiDegerler_engine';
import { calculateLgsPusulasi } from './utils/LgsPusulasi_engine';
import { calculateSinavKaygisi } from './utils/SinavKaygisi_engine';
import { calculateBeckAnksiyete } from './utils/BeckAnksiyete_engine';
import { calculateDevamsizlik } from './utils/Devamsizlik_engine';
import { calculateMeslekiEgilim } from './utils/MeslekiEgilim_engine';
import { calculateRosenberg } from './utils/Rosenberg_engine';
import { calculateKariyerPusulasi } from './utils/KariyerPusulasi_engine';
import { calculateVAK } from './utils/VAK_engine';
import { calculateLiebowitz } from './utils/liebowitz_engine';
import { calculateAsrs } from './utils/Asrs_engine';
import { calculateDass21 } from './utils/Dass21_engine';
import { calculateSnapIV } from './utils/SnapIV_engine';
import { calculateCokluZeka } from './utils/CokluZeka_engine';
import { calculateYasamPencerem } from './utils/YasamPencerem_engine';
import { calculatePsikolojikSaglamlik } from './utils/psikolojikSaglamlik_engine';
import { calculateInternetBagimliligi } from './utils/InternetBagimliligi_engine';
import { calculateBasarisizlik } from './utils/Basarisizlik_engine';
import { calculateStudentInfo } from './utils/StudentInfo_engine';
import { calculateRibaIndividual, calculateRibaClassASP, calculateRibaSchoolASP } from './utils/Riba_engine';
import { generatePDF } from './utils/pdfGenerator';



// --- BİLEŞENLER(COMPONENTS) ---
import LandingPage from './components/LandingPage';
import ParticipantLogin from './components/ParticipantLogin';
import PlanningCenter from './components/planning/PlanningCenter';
import Sidebar from './components/Sidebar';
import RibaSurvey from './components/RibaSurvey';
import ClinicianLogin from './components/ClinicianLogin';
import RegisterPage from './components/RegisterPage';
import PricingPage from './components/PricingPage';
import StudentFeedbackUI from './components/StudentFeedbackUI';
import ConfirmModal from './components/ConfirmModal';
import ClassManager from './components/ClassManager';
import TestForm from './components/TestForm';
import CareerCompass from './components/CareerCompass';
import TestsPage from './components/TestsPage';
import DashboardHome from './components/DashboardHome';
import AdminPanel from './components/AdminPanel';
import StudentDashboard from './components/StudentDashboard';
import StudentPlanner from './components/StudentPlanner';
import CoachingPanel from './components/CoachingPanel';
import KnowledgeBase from './components/KnowledgeBase';
import UserGuide from './components/UserGuide';
import MaterialsLibrary from './components/MaterialsLibrary';
import AIFormatter from './components/AIFormatter';
import EditableAIBox from './components/EditableAIBox';
import StudentFolders from './components/StudentFolders';
import AIWorkshop from './components/AIWorkshop';
import ReportViewer from './components/ReportViewer';
import InstitutionalAnalysis from './components/InstitutionalAnalysis';


// --- REPORTS ---
import { 
  BasarisizlikReportUI, 
  aggregateBasarisizlik, 
  BasarisizlikKurumsalUI 
} from './components/reports/BasarisizlikReports';

import { 
  BeckAnksiyeteReportUI, 
  aggregateBeckAnksiyete, 
  BeckAnksiyeteKurumsalUI 
} from './components/reports/BeckAnksiyeteReports';

import LgsPusulasiReportUI from './components/reports/LgsPusulasiReports';
import { MeslekiEgilimReportUI } from './components/reports/MeslekiEgilimReports';

import { 
  YasamPenceremReportUI, 
  aggregateYasamPencerem, 
  YasamPenceremKurumsalUI 
} from './components/reports/YasamPenceremReports';

import { KariyerPusulasiReportUI } from './components/reports/KariyerPusulasiReports';

import { 
  MeslekiDegerlerReportUI, 
  aggregateMeslekiDegerler, 
  MeslekiDegerlerKurumsalUI 
} from './components/reports/MeslekiDegerlerReports';

import { 
  DevamsizlikReportUI, 
  aggregateDevamsizlik, 
  DevamsizlikKurumsalUI 
} from './components/reports/DevamsizlikReports';

import { 
  SinavKaygisiReportUI, 
  aggregateSinavKaygisi, 
  SinavKaygisiKurumsalUI 
} from './components/reports/SinavKaygisiReports';

import { 
  InternetBagimliligiReportUI, 
  aggregateInternetBagimliligi, 
  InternetKurumsalUI 
} from './components/reports/InternetBagimliligiReports';

import { 
  Dass21ReportUI, 
  aggregateDass21, 
  Dass21KurumsalUI 
} from './components/reports/Dass21Reports';

import { 
  RosenbergReportUI, 
  aggregateRosenberg, 
  RosenbergKurumsalUI 
} from './components/reports/RosenbergReports';

import { 
  HollandReportUI, 
  aggregateHolland, 
  HollandKurumsalUI 
} from './components/reports/HollandReports';

import { 
  VakReportUI, 
  aggregateVAK, 
  VakKurumsalUI 
} from './components/reports/VakReports';

import { 
  CokluZekaReportUI, 
  aggregateCokluZeka, 
  CokluZekaKurumsalUI 
} from './components/reports/CokluZekaReports';

import { AsrsReportUI } from './components/reports/AsrsReports';
import { SnapIVReportUI } from './components/reports/SnapIVReports';
import { BanaKendiniAnlatReportUI } from './components/reports/BanaKendiniAnlatReports';
import { SosyometriKurumsalUI } from './components/reports/SosyometriReports';

import { 
  StudentInfoReportUI, 
  aggregateStudentInfo, 
  StudentInfoKurumsalUI 
} from './components/reports/StudentInfoReports';

import { 
  PsikolojikSaglamlikReportUI, 
  PsikolojikSaglamlikBulkReportUI 
} from './components/reports/psikolojikSaglamlikReports';

import { 
LiebowitzReportUI, 
LiebowitzBulkReportUI 
} from './components/reports/liebowitzReports';




// --- AYARLAR ---
const FIREBASE_HOSTING_URL = "https://rehber360-e0808.web.app"; 
const AI_API_URL = "https://generateanalysis-yyf3isw5zq-uc.a.run.app";




// ============================================================
// EĞİTİM ÖĞRETİM YILI YÖNETİMİ
// ============================================================
const ACTIVE_ACADEMIC_YEAR = "2026-2027";
const LEGACY_ACADEMIC_YEAR = "2025-2026";

const ACADEMIC_YEARS = [
  ACTIVE_ACADEMIC_YEAR,
  LEGACY_ACADEMIC_YEAR
];

// Eğitim yılı özelliğinden önce oluşturulan kayıtlar
// geçmiş dönem kaydı kabul edilir.
const resolveAcademicYear = (record) => {
  return record?.academicYear || LEGACY_ACADEMIC_YEAR;
};





const CRITICAL_ITEMS_IDS = [3, 7, 9, 11, 14, 16, 18, 25, 33, 36];

const AVAILABLE_TESTS = NEW_FORMS.map(form => ({
  id: form.id, name: form.title, category: 'Psikolojik Değerlendirme',
  description: form.description, type: form.type, options: form.options, questions: form.items, intro: form.intro,
  reference: form.reference // 🎯 SİHİRLİ DOKUNUŞ: Atıf bilgisini buraya çektik
}));








// --- PUANLAMA MOTORU (AKILLI MERKEZİ SANTRAL) ---
const calculateUniversalScore = (answers, testId) => {
  // 1. ÖNCE ÖZEL VE KRİTİK MOTORLARI ÇALIŞTIR (VİP ŞERİDİ)
  // Buradaki motorlar isCritical (18. madde) gibi hayati kuralları kendi içinde hesaplar.
  if (testId === 'yasam_pencerem' || testId?.includes('yasam')) return calculateYasamPencerem(answers);
  if (testId === 'dass_21') return calculateDass21(answers);
  if (testId === 'snap_iv_form') return calculateSnapIV(answers);
  if (testId === 'rosenberg_benlik_saygisi') return calculateRosenberg(answers);
  if (testId === 'mesleki_egilim_belirleme') return calculateMeslekiEgilim(answers);
  if (testId === 'beck_anksiyete' || testId?.includes('beck')) return calculateBeckAnksiyete(answers);
  if (testId === 'yasam_pencerem' || testId?.includes('yasam')) return calculateYasamPencerem(answers);
  if (testId === 'holland_inventory') return calculateHolland(answers);
  if (testId === 'kariyer_pusulasi') return calculateKariyerPusulasi(answers);
  if (testId === 'lgs_pusulasi' || testId?.includes('lgs')) return calculateLgsPusulasi(answers);
  if (testId === 'kisa_psikolojik_saglamlik' || testId?.includes('saglamlik')) return calculatePsikolojikSaglamlik(answers);
  if (testId === 'liebowitz_sosyal_kaygi' || testId?.includes('liebowitz')) return calculateLiebowitz(answers);
  if (testId === 'sinav_kaygisi' || testId?.includes('sinav')) return calculateSinavKaygisi(answers);
  if (testId === 'mesleki_degerler_envanteri' || testId?.includes('degerler')) return calculateMeslekiDegerler(answers);
  if (testId === 'basarisizlik_nedenleri' || testId?.includes('basarisizlik')) return calculateBasarisizlik(answers);
  if (testId === 'ogrenci_bilgi_formu' || testId?.includes('bilgi')) return calculateStudentInfo(answers);
  if (testId === 'devamsizlik_nedenleri' || testId?.includes('devamsizlik')) return calculateDevamsizlik(answers);
  if (testId && testId.includes('riba')) return calculateRibaIndividual(answers);
  if (testId === "internet_bagimliligi" || testId?.includes("bagimlilik")) return calculateInternetBagimliligi(answers);
  if (testId === 'asrs_form' || testId?.includes('asrs')) return calculateAsrs(answers);
  if (testId === 'coklu_zeka_envanteri' || testId?.includes('coklu_zeka')) return calculateCokluZeka(answers);
  if (testId === 'vak_inventory' || testId?.includes('vak')) return calculateVAK(answers);

  

  // 3. HİÇBİRİNE UYMUYORSA BOŞ BİR GÜVENLİK ZARFI DÖN
  return { summary: "İşlendi", analysis: "Veriler kaydedildi.", risks: [], chartData: [], isCritical: false, masterRisk: 'none', domain: 'unknown' };
};


// --- STİLLER ---
const PrintStyles = () => (<style>{`
  @media print { 
    @page { size: A4 portrait; margin: 10mm; } 
    body { 
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
        -webkit-print-color-adjust: exact !important; 
        print-color-adjust: exact !important; 
        background-color: white !important;
    }
    .no-print { display: none !important; }
    .avoid-break { page-break-inside: avoid !important; break-inside: avoid !important; }
  }
`}</style>);

// --- DATABASE HELPER ---
const DB = {
  login: loginUser,
  register: registerUser,
  logout: logoutUser,
  getProfile: getUserProfile,
  consumeCredit: consumeCredit, 
  
  useLiveSubmissions(setSubmissions, user) { 
    useEffect(() => { 
      if (!user || !user.refCode) return; 

      const q = query(collection(db, "submissions"), where("clinicianUid", "==", user.uid));
      
      const unsubscribe = onSnapshot(q, (snapshot) => { 
        // SİHİRLİ DOKUNUŞ BURADA: Eski sayısal kimlikleri eziyoruz, gerçek Firebase kimliğini (doc.id) zorla mühürlüyoruz!
        const myData = snapshot.docs.map(doc => ({ ...doc.data(), firebaseId: doc.id, id: doc.id }));
        setSubmissions(myData.sort((a,b) => (b.timestamp || "").localeCompare(a.timestamp || ""))); 
      }, (error) => {
        console.error("Submissions çekme hatası:", error);
      }); 

      return () => unsubscribe(); 
    }, [setSubmissions, user]); 
  },
  
  useLiveClasses(setClasses, user) { 
    useEffect(() => { 
      if (!user || !user.refCode) return;

      const q = query(collection(db, "classes"), where("clinicianUid", "==", user.uid));
      
      const unsubscribe = onSnapshot(q, (snapshot) => { 
        const myClasses = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setClasses(myClasses); 
      }, (error) => {
        console.error("Classes çekme hatası:", error);
      }); 

      return () => unsubscribe(); 
    }, [setClasses, user]); 
  },

    async saveSubmission(submission) { 
    try {
      // SİMÜLATÖR KORUMASI: Sahte veriyse Firebase'e yollama
      if (String(submission.id).includes('_')) return true;

      const docId =
        submission.firebaseId ||
        (
          typeof submission.id === 'string' &&
          submission.id.length > 15
            ? submission.id
            : null
        );

      if (docId) {

        // MEVCUT KAYIT:
        // updateInCloud başarıda true, hatada false döndürür.
        const updateSuccess =
          await updateInCloud(
            "submissions",
            docId,
            submission
          );

        return updateSuccess === true;

      } else {

        // YENİ KAYIT:
        // saveToCloud başarıda Firebase document id,
        // hatada null döndürür.
        const newDocId =
          await saveToCloud("submissions", {
            ...submission,
            academicYear:
              submission.academicYear ||
              ACTIVE_ACADEMIC_YEAR,
            timestamp:
              new Date().toISOString()
          });

        return Boolean(newDocId);
      }

    } catch (e) {
      console.error(
        "Firebase kayıt işlemi başarısız:",
        e
      );

      return false;
    }
  },

  async analyzeData(sub) { 
    if (!sub) return { summary: "Veri Yok", analysis: "..." }; 
    const existingAiAnalysis = sub.reportData?.aiAnalysis; 
    const result = calculateUniversalScore(sub.answers, sub.testId); 
    if (existingAiAnalysis) { result.aiAnalysis = existingAiAnalysis; } 
    return result; 
  },

  async deleteSubmission(id) { 
    if (!id) return; 
    try {
      if (String(id).includes('_')) {
          alert("Bu bir test verisidir. Ekrandan kaldırmak için 'Testi Temizle' butonunu kullanın.");
          return;
      }
      // Doğru kimlikle ve metin (String) formatında silme işlemi
      await deleteFromCloud("submissions", String(id)); 
    } catch (e) {
      console.log("Silme Hatası Savuşturuldu:", e.message);
    }
  },

  async clearAllSubmissions(user) { 
    if (!user || !user.refCode) return false;
    
    try {
      const q = query(collection(db, "submissions"), where("clinicianUid", "==", user.uid));
      const querySnapshot = await getDocs(q);
      
      const batch = writeBatch(db);
      querySnapshot.forEach((document) => {
        batch.delete(doc(db, "submissions", document.id));
      });
      
      await batch.commit();
      return true;
    } catch (error) {
      console.error("Silme hatası:", error);
      return false;
    }
  }
};

// --- BİLEŞENLER ---

const UpgradePrompt = () => (
  <div className="flex flex-col items-center justify-center h-full p-8 text-center animate-in fade-in zoom-in duration-500">
    <div className="bg-gradient-to-br from-amber-100 to-orange-100 p-8 rounded-[2.5rem] border border-amber-200 shadow-xl max-w-lg">
      <div className="h-20 w-20 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-6 text-white shadow-lg"><Star className="h-10 w-10 fill-current" /></div>
      <h2 className="text-3xl font-black text-amber-900 mb-2">Premium Özellik</h2>
      <p className="text-amber-800 mb-6 font-medium">Kurumsal Analiz, Sınıf Risk Haritaları ve Sınırsız AI Raporlama özellikleri sadece <strong>Premium Okullar</strong> içindir.</p>
      <div className="bg-white/60 p-4 rounded-xl mb-6 text-sm text-amber-900 text-left space-y-2">
        <div className="flex items-center"><CheckCircle className="h-4 w-4 mr-2 text-green-600"/> Sınırsız Öğrenci Analizi</div>
        <div className="flex items-center"><CheckCircle className="h-4 w-4 mr-2 text-green-600"/> Detaylı Sınıf & Okul Raporları</div>
        <div className="flex items-center"><CheckCircle className="h-4 w-4 mr-2 text-green-600"/> Öncelikli AI Erişimi</div>
      </div>
      <button onClick={() => alert("Premium geçiş için lütfen kurum yetkilisi ile iletişime geçiniz.")} className="w-full py-4 bg-amber-600 hover:bg-amber-700 text-white rounded-xl font-bold transition shadow-lg flex items-center justify-center"><CreditCard className="h-5 w-5 mr-2"/> Premium'a Geç</button>
    </div>
  </div>
);



















// --- MAIN LAYOUT ---
const MainLayout = ({
  user,
  submissions,
  academicYear,
  onAcademicYearChange,
  onLogout,
  onAnalyze,
  onBulkAnalyze,
  onPlanSubmit,
  initialTestId,
  onMigrate,
  onLoadMore,
  hasMore,
  onRefreshData,
  onDelete,
  setGlobalModal,
  closeGlobalModal,
  triggerModal
}) => {
  const [view, setView] = useState(user.role === 'student' ? 'student-dashboard' : 'dashboard'); 
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false); 
  const [activeTest, setActiveTest] = useState(null); 
  const [studentRiskLevel, setStudentRiskLevel] = useState('medium');
const [studentFeedbackData, setStudentFeedbackData] = useState(null);  

const [
  managedClasses,
  setManagedClasses
] = useState([]);


/*
 * Sınıf Yönetimi'nde tanımlı sınıfları
 * Planlama Merkezi dahil MainLayout içindeki
 * ekranlarda ortak kullanabilmek için canlı tut.
 */
DB.useLiveClasses(
  setManagedClasses,
  user
);




  // --- FİLTRELEME DURUMLARI ---
  const [searchTerm, setSearchTerm] = useState('');
  const [classFilter, setClassFilter] = useState('');
  const [testFilter, setTestFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
// 🚀 İSTEMCİ TARAFLI NUMARALI SAYFALAMA HAFIZASI
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 50;

  // Arama veya filtreleme yapıldığında otomatik olarak 1. sayfaya dön
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, classFilter, testFilter, statusFilter]);

  // Sayfalama hesaplamaları
  

  // 🌟 YENİ: TARAYICI GERİ TUŞU (HISTORY API) İÇİN DOĞRU YER 🌟
  useEffect(() => {
    // Uzman Paneli içindeki her sekme değişiminde URL'yi sessizce güncelle
    window.history.pushState({ dashboardView: view }, '', `?view=${view}`);
    // F5'e basıldığında aynı ekranda kalması için hafızayı da güncelle
    localStorage.setItem('rehber360_view', view); 
  }, [view]);

   useEffect(() => {
    const handlePopState = (event) => {
      if (event.state && event.state.dashboardView) {
        // Geçmişteki menü ekranına dön
        setView(event.state.dashboardView);
      } else {
        // Çok geriye basıp sistem dışına çıkmaya çalışırsa
        // varsayılan ekrana sabitle.
        setView(
          user.role === 'student'
            ? 'student-dashboard'
            : 'dashboard'
        );
      }
    };

    window.addEventListener(
      'popstate',
      handlePopState
    );

    return () =>
      window.removeEventListener(
        'popstate',
        handlePopState
      );
  }, [user.role]);


 


  // -------------------------------------------------------------------
  
  useEffect(() => { 
    if (initialTestId && user.role === 'student') { 
      // 1. ZIRH: Linkin sonuna bulaşan görünmez boşlukları veya slash'leri yokediyoruz
      const cleanId = String(initialTestId).replace(/[^a-zA-Z0-9_]/g, '');
      const targetTest = AVAILABLE_TESTS.find(t => String(t.id).replace(/[^a-zA-Z0-9_]/g, '') === cleanId); 
      
      if (targetTest) { 
          // 2. ZIRH: React anasayfayı yükledikten saliseler sonra testi "ZORLA" ekrana çakıyoruz.
          setTimeout(() => {
              setActiveTest(targetTest); 
              setView('test-form'); 
          }, 150); 
      } 
    } 
  }, [initialTestId, user.role]);
  const myData = user.role === 'specialist'
  ? submissions.filter(
      s =>
        String(s.clinicianCode) === String(user.refCode) &&
        resolveAcademicYear(s) === academicYear
    )
  : [];
  
  // --- FİLTRELEME MANTIĞI ---
  const uniqueClasses = [...new Set(myData.map(s => s.studentClass))].sort();
  const uniqueTests = [...new Set(myData.map(s => s.testName))].sort();

  const filteredData = myData.filter(s => {
      const matchSearch = s.studentNo.includes(searchTerm) || (s.studentName && s.studentName.toLowerCase().includes(searchTerm.toLowerCase()));
      const matchClass = classFilter ? s.studentClass === classFilter : true;
      const matchTest = testFilter ? s.testName === testFilter : true;
      const matchStatus = statusFilter ? s.status === statusFilter : true;
      return matchSearch && matchClass && matchTest && matchStatus;
  });

const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentTableData = filteredData.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const pendingSubs = filteredData.filter(s => s.status === 'pending');
  // --------------------------

  const handleStartTest = (test) => {
  setStudentFeedbackData(null);
  setStudentRiskLevel('medium');
  setActiveTest(test);
  setView('test-form');
}; 
  const handleArchiveAll = () => { const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(myData, null, 2)); const downloadAnchorNode = document.createElement('a'); downloadAnchorNode.setAttribute("href", dataStr); downloadAnchorNode.setAttribute("download", `rehber360_yedek_${new Date().toISOString().slice(0,10)}.json`); document.body.appendChild(downloadAnchorNode); downloadAnchorNode.click(); downloadAnchorNode.remove(); }; 
  const handleDeleteAll = () => { 
    setGlobalModal({
      isOpen: true,
      type: 'danger',
      title: '⚠️ Tüm Verileri Sil',
      message: 'TÜM ÖĞRENCİ VERİLERİNİ SİLMEK ÜZERESİNİZ!\n\nBu işlem geri alınamaz. Onaylıyor musunuz?',
      confirmText: 'Evet, Kalıcı Olarak Sil',
      onConfirm: async () => {
        closeGlobalModal();
        await DB.clearAllSubmissions(user); 
        // Silme bitince başarı modalı göster
        setTimeout(() => {
          setGlobalModal({ isOpen: true, type: 'success', title: 'Başarılı', message: 'Tüm veriler başarıyla temizlendi.', onConfirm: closeGlobalModal });
        }, 500);
      }
    });
  };
  // --- YENİ: TOPLU PDF İNDİRME MOTORU VE STATELERİ ---
  const [bulkPrintData, setBulkPrintData] = useState(null);
  const [isBulkPrinting, setIsBulkPrinting] = useState(false);

  useEffect(() => {
      if (bulkPrintData && isBulkPrinting) {
          setTimeout(() => {
              const content = document.getElementById('hidden-bulk-print-area').innerHTML;
              const iframe = document.createElement('iframe');
              iframe.style.position = 'fixed';
              iframe.style.right = '0';
              iframe.style.bottom = '0';
              iframe.style.width = '1024px';
              iframe.style.height = '100%';
              iframe.style.zIndex = '-1';
              iframe.style.opacity = '0';
              iframe.style.border = '0';
              document.body.appendChild(iframe);
              
              const doc = iframe.contentWindow.document;
              doc.open();
              doc.write(`
                  <html>
                  <head>
                      <title>Toplu Öğrenci Raporları</title>
                      <script src="https://cdn.tailwindcss.com"></script>
                      <style>
                          @media print { 
                              @page { size: A4 portrait; margin: 10mm; } 
                              body { font-family: 'Segoe UI', sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; background: white; } 
                              .page-break { page-break-after: always; clear: both; } 
                              .avoid-break { page-break-inside: avoid !important; }
                              .bg-slate-900 { background-color: #0f172a !important; color: white !important; }
                          }
                      </style>
                  </head>
                  <body class="bg-white text-black">
                      ${content}
                  </body>
                  </html>
              `);
              doc.close();
              
              iframe.onload = () => { 
                  setTimeout(() => { 
                      iframe.contentWindow.focus(); 
                      iframe.contentWindow.print(); 
                      
                      // 1. ARAYÜZÜ HEMEN SERBEST BIRAK (Kullanıcı butonu kilitli kalmasın)
                      setIsBulkPrinting(false);
                      setBulkPrintData(null);

                      // 2. MOBİL SAFARİ BEYAZ EKRAN KORUMASI
                      // Arka plandaki iframe'i çok uzun süre silmiyoruz ki iOS çökmesin.
                      setTimeout(() => {
                          if (document.body.contains(iframe)) {
                              document.body.removeChild(iframe); 
                          }
                      }, 999000000);
                      
                  }, 1500); 
              };
          }, 2000);
      }
  }, [bulkPrintData, isBulkPrinting]);

  const handleStartBulkPrint = () => {
      if (filteredData.length === 0) return alert("Ekranda yazdırılacak öğrenci yok!");
      if (!testFilter) return alert("Lütfen önce yukarıdaki menüden TEK BİR TEST seçin. (Örn: Sadece Yaşam Pencerem). Karışık testleri aynı anda yazdıramazsınız.");
      
      const confirm = window.confirm(`Ekranda filtrelenmiş ${filteredData.length} öğrencinin bireysel raporu TEK BİR PDF dosyasında birleştirilecek. Bu işlem birkaç saniye sürebilir. Onaylıyor musunuz?`);
      if (confirm) {
          setIsBulkPrinting(true);
          setBulkPrintData(filteredData);
      }
  };
  // ----------------------------------------------------

  return ( 
    <div className="flex min-h-screen bg-slate-50 font-sans text-slate-900 no-print"> 
      <Sidebar
  currentView={view}
  setView={setView}
  onLogout={onLogout}
  user={user}
  isOpen={mobileMenuOpen}
  onClose={() => setMobileMenuOpen(false)}
  academicYear={academicYear}
  activeAcademicYear={ACTIVE_ACADEMIC_YEAR}
      academicYears={ACADEMIC_YEARS}
  onAcademicYearChange={onAcademicYearChange}
/>
      <div className="flex-1 md:ml-64 flex flex-col h-screen"> 
        <div className="md:hidden bg-white p-4 border-b border-slate-200 flex items-center justify-between sticky top-0 z-30"> 
          <h1 className="text-xl font-black text-slate-900">Rehber360</h1> 
          <button onClick={() => setMobileMenuOpen(true)} className="p-2 bg-slate-100 rounded-lg text-slate-600 hover:bg-slate-200"><Menu className="h-6 w-6"/></button> 
        </div> 
        <div className="flex-1 p-6 md:p-10 overflow-y-auto"> 
          {user.role === 'specialist' && ( 
            <> {view === 'dashboard' && (
  <DashboardHome
    submissions={myData}
    user={user}
    setView={setView}
    onAnalyze={onAnalyze}
    academicYear={academicYear}
  />
)}
 {view === 'planning-center' && (
  <PlanningCenter
    key={`${user.uid}_${academicYear}`}
    academicYear={academicYear}
    user={user}
    managedClasses={managedClasses}
    onOpenClassManager={() =>
      setView('class-manager')
    }
  />
)}
              {view === 'guide' && <UserGuide />}
              {view === 'materials' && <MaterialsLibrary user={user} onUpgrade={() => setView('pricing')} triggerModal={triggerModal} />}
              {view === 'ai-workshop' && <AIWorkshop user={user} onUpgrade={() => setView('pricing')} />}
              {view === 'class-analysis' && (
  <InstitutionalAnalysis
    submissions={myData}
    user={user}
    academicYear={academicYear}
  />
)}
              {view === 'class-manager' && (
  <ClassManager
    user={user}
    academicYear={academicYear}
    activeAcademicYear={ACTIVE_ACADEMIC_YEAR}
  />
)} 

{view === 'student-folders' && (
      <StudentFolders
        submissions={myData}
        onAnalyze={onAnalyze}
        user={user}
        academicYear={academicYear}
      />
    )}

             {view === 'coaching' && (
  <CoachingPanel
    user={user}
    submissions={myData}
    onAssign={onPlanSubmit}
    academicYear={academicYear}
  />
)}
              {view === 'career-compass' && <CareerCompass user={user} submissions={myData} onSaveSubmission={DB.saveSubmission} onAnalyze={onAnalyze} onUpgrade={() => setView('pricing')} />}
              
       
             {/* ÖĞRENCİ LİSTESİ */}
              {view === 'students' && ( 
                <div className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden"> 
                  
                  {/* Başlık ve Toplu Analiz Butonu */}
                  <div className="p-6 md:p-8 border-b border-slate-100 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <div>
                        <h2 className="text-2xl font-black text-slate-800">Öğrenci Listesi</h2>
                        <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-bold mt-2 inline-block">
                            Toplam {filteredData.length} Kayıt Bulundu
                        </span>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      <button onClick={handleStartBulkPrint} disabled={isBulkPrinting} className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-bold text-xs flex items-center transition shadow-md shadow-purple-200">
                          {isBulkPrinting ? <Loader2 className="h-4 w-4 mr-2 animate-spin"/> : <Download className="h-4 w-4 mr-2"/>} 
                          {isBulkPrinting ? "PDF Hazırlanıyor..." : "Toplu Bireysel PDF Al"}
                      </button>

                      {pendingSubs.length > 0 && (
                        <button onClick={() => onBulkAnalyze(pendingSubs)} className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-xl font-bold text-xs flex items-center transition shadow-md shadow-amber-200">
  <Activity className="h-4 w-4 mr-2"/> 
  {user.isPremium ? `⚡ ${pendingSubs.length} Bekleyeni Analiz Et` : `⚡ Analiz Et (${pendingSubs.length} Kredi)`}
</button>
                      )}
                      <button onClick={handleArchiveAll} className="px-4 py-2 bg-white border border-slate-200 text-slate-600 hover:bg-slate-50 rounded-xl font-bold text-xs flex items-center transition"><FolderDown className="h-4 w-4 mr-2"/> Excel Arşivi</button>
                      <button onClick={handleDeleteAll} className="px-4 py-2 bg-red-50 text-red-600 hover:bg-red-100 rounded-xl font-bold text-xs flex items-center transition"><Trash2 className="h-4 w-4 mr-2"/> Sil</button>
                    </div>
                  </div>

                  {/* FİLTRELEME ÇUBUĞU */}
                  <div className="bg-slate-50 p-4 border-b border-slate-200 grid grid-cols-1 md:grid-cols-4 gap-4">
                      <div className="relative">
                          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                          <input type="text" placeholder="Öğrenci No Ara..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-9 pr-3 py-2 rounded-xl border border-slate-200 text-sm font-medium focus:ring-2 focus:ring-blue-500 outline-none" />
                      </div>
                      <select value={classFilter} onChange={e => setClassFilter(e.target.value)} className="w-full px-3 py-2 rounded-xl border border-slate-200 text-sm font-medium focus:ring-2 focus:ring-blue-500 outline-none cursor-pointer">
                          <option value="">Tüm Sınıflar</option>
                          {uniqueClasses.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                      <select value={testFilter} onChange={e => setTestFilter(e.target.value)} className="w-full px-3 py-2 rounded-xl border border-slate-200 text-sm font-medium focus:ring-2 focus:ring-blue-500 outline-none cursor-pointer">
                          <option value="">Tüm Envanterler</option>
                          {uniqueTests.map(t => <option key={t} value={t}>{t}</option>)}
                      </select>
                      <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="w-full px-3 py-2 rounded-xl border border-slate-200 text-sm font-medium focus:ring-2 focus:ring-blue-500 outline-none cursor-pointer">
                          <option value="">Tüm Durumlar</option>
                          <option value="pending">Sadece Bekleyenler (İncelenecek)</option>
                          <option value="reported">İncelenmiş Olanlar</option>
                      </select>
                  </div>

                  <div className="overflow-x-auto min-h-[400px]">
                    <table className="w-full text-left">
                      <thead className="bg-white text-xs font-bold text-slate-400 uppercase">
                        <tr className="border-b border-slate-100"><th className="p-6">Öğrenci</th><th className="p-6">Form / İşlem</th><th className="p-6 text-right no-print">Durum</th></tr>
                      </thead>
                      <tbody className="divide-y divide-slate-50 text-sm text-slate-700">
                        {filteredData.length === 0 ? (
                            <tr><td colSpan="3" className="p-10 text-center text-slate-400 font-medium">Aradığınız kriterlere uygun veri bulunamadı.</td></tr>
                        ) : (
                            // 🚀 DİLİMLENMİŞ VERİYİ (currentTableData) KULLANIYORUZ
                            currentTableData.map(s => (
                            <tr key={s.id} className="hover:bg-slate-50 transition group">
                                <td className="p-6 font-bold"><div className="flex items-center gap-3"><div className="h-8 w-8 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center font-bold text-xs">{s.studentClass.substring(0,s.studentClass.indexOf('/'))}</div>{s.studentClass} - {s.studentNo}</div></td>
                                <td className="p-6"><span className="bg-slate-100 text-slate-600 px-2 py-1 rounded text-xs font-bold border border-slate-200">{s.testName}</span></td>
                                <td className="p-6 text-right no-print">
                                <div className="flex items-center justify-end gap-3">
                                    {s.status === 'pending' && <span className="flex items-center text-amber-500 text-xs font-bold"><div className="h-2 w-2 rounded-full bg-amber-500 mr-1 animate-pulse"></div>Bekliyor</span>}
                                    {s.status === 'reported' && <span className="flex items-center text-green-500 text-xs font-bold"><CheckCircle className="h-3 w-3 mr-1"/>İncelendi</span>}
                             <button onClick={() => onAnalyze(s)} className="px-4 py-2 bg-slate-900 text-white rounded-lg font-bold text-xs hover:bg-blue-600 transition flex items-center shadow-sm">
  <Activity className="h-3 w-3 mr-2"/> 
  {user.isPremium ? "Görüntüle" : "Görüntüle (1 Kredi)"}
</button>
                                   <button onClick={async (e) => { e.stopPropagation(); if(window.confirm(`${s.studentNo} nolu öğrencinin "${s.testName}" kaydını silmek istediğinize emin misiniz?`)) { await DB.deleteSubmission(s.firebaseId || s.id); if(onDelete) onDelete(s.firebaseId || s.id); }}} className="p-2 bg-white text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg border border-slate-200 transition shadow-sm"><Trash2 className="h-4 w-4"/></button>
                                </div>
                                </td>
                            </tr>
                            ))
                        )}
                      </tbody>
                    </table>
                  </div> 
                  
                  {/* 🚀 ŞIK NUMARALI SAYFALAMA ALANI */}
                  {totalPages > 1 && (
                      <div className="p-4 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between bg-slate-50 rounded-b-3xl gap-4">
                          <span className="text-xs font-bold text-slate-500">
                              Gösterilen: {startIndex + 1} - {Math.min(startIndex + ITEMS_PER_PAGE, filteredData.length)}
                          </span>
                          
                          <div className="flex items-center gap-1 bg-white p-1 rounded-xl border border-slate-200 shadow-sm">
                              <button 
                                  onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                                  disabled={currentPage === 1}
                                  className="px-3 py-1.5 rounded-lg text-slate-600 disabled:opacity-40 hover:bg-slate-100 text-xs font-bold transition flex items-center"
                              >
                                  <ChevronRight className="h-4 w-4 mr-1 rotate-180"/> Önceki
                              </button>
                              
                              {/* 1 2 3 4 5 Butonları */}
                              <div className="flex items-center gap-1 px-2 border-x border-slate-100">
                                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                                      <button
                                          key={page}
                                          onClick={() => setCurrentPage(page)}
                                          className={`w-8 h-8 rounded-lg text-xs font-bold transition flex items-center justify-center
                                              ${currentPage === page 
                                                  ? 'bg-blue-600 text-white shadow-md shadow-blue-200' 
                                                  : 'bg-transparent text-slate-600 hover:bg-slate-100'
                                              }`}
                                      >
                                          {page}
                                      </button>
                                  ))}
                              </div>

                              <button 
                                  onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                                  disabled={currentPage === totalPages}
                                  className="px-3 py-1.5 rounded-lg text-slate-600 disabled:opacity-40 hover:bg-slate-100 text-xs font-bold transition flex items-center"
                              >
                                  Sonraki <ChevronRight className="h-4 w-4 ml-1"/>
                              </button>
                          </div>
                      </div>
                  )}
                </div> 
              )}

              {view === 'tests' && <TestsPage onSelectTest={()=>{}} user={user} />} 
              
              {view === 'settings' && (
                <div className="max-w-6xl mx-auto animate-in fade-in duration-500">
                  <div className="mb-8">
                     <h2 className="text-3xl font-black text-slate-800 tracking-tight">Ayarlar</h2>
                     <p className="text-slate-500 mt-1 font-medium">Hesap, güvenlik ve sistem tercihlerinizi yönetin.</p>
                  </div>

                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                     
                     {/* SOL KOLON: Profil ve Güvenlik */}
                     <div className="lg:col-span-1 space-y-6">
                        
                        {/* Profil Özeti */}
                        <div className="bg-white p-6 rounded-3xl border border-slate-200 shadow-sm">
                           <div className="flex flex-col items-center text-center">
                              <div className="h-24 w-24 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-full flex items-center justify-center text-blue-600 mb-4 shadow-inner border border-blue-200">
                                 <User className="h-10 w-10"/>
                              </div>
                              <h3 className="font-black text-xl text-slate-800">{user.fullName}</h3>
                              <p className="text-slate-500 text-sm font-medium mt-1 flex items-center justify-center"><School className="h-4 w-4 mr-1.5"/> {user.schoolName}</p>
                              
                              <div className="mt-6 bg-slate-50 px-4 py-3 rounded-2xl border border-slate-200 w-full">
                                 <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Kurumsal PDR Kodu</p>
                                 <p className="text-2xl font-mono font-black text-indigo-600 tracking-wider">{user.refCode}</p>
                              </div>
                           </div>
                        </div>

                        {/* Güvenlik */}
                        <div className="bg-white p-6 rounded-3xl border border-slate-200 shadow-sm">
                           <h3 className="font-bold text-slate-800 mb-4 flex items-center text-sm uppercase tracking-widest border-b border-slate-100 pb-3">
                             <Shield className="h-5 w-5 mr-2 text-slate-500"/> Güvenlik
                           </h3>
                           <button 
                              onClick={async () => {
                                 const userEmail = prompt("Şifre sıfırlama bağlantısı göndermek için e-posta adresinizi giriniz:", user.email || "");
                                 if(userEmail) {
                                    try {
                                       await resetUserPassword(userEmail);
                                       alert("✅ Şifre sıfırlama bağlantısı e-posta adresinize başarıyla gönderildi!");
                                    } catch(e) {
                                       alert("⚠️ Bir hata oluştu. E-posta adresinizi doğru yazdığınızdan emin olun.");
                                    }
                                 }
                              }} 
                              className="w-full flex items-center justify-between p-3 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-xl transition cursor-pointer group"
                           >
                              <div className="flex items-center">
                                 <div className="h-10 w-10 bg-white rounded-lg flex items-center justify-center shadow-sm border border-slate-200 mr-3 group-hover:text-blue-600 transition">
                                   <Lock className="h-4 w-4"/>
                                 </div>
                                 <div className="text-left">
                                   <p className="text-sm font-bold text-slate-700 group-hover:text-blue-700 transition">Şifreyi Değiştir</p>
                                   <p className="text-[10px] text-slate-500 font-medium">Sıfırlama e-postası gönder</p>
                                 </div>
                              </div>
                              <ChevronRight className="h-4 w-4 text-slate-400 group-hover:text-blue-600 transition"/>
                           </button>
                        </div>

                     </div>

                     {/* SAĞ KOLON: Krediler ve Sistem Tercihleri */}
                     <div className="lg:col-span-2 space-y-6">
                        
                        {/* Krediler ve Abonelik */}
                        <div className="bg-white p-6 md:p-8 rounded-3xl border border-slate-200 shadow-sm">
                           <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center border-b border-slate-100 pb-4 mb-5 gap-3">
                              <h3 className="font-bold text-slate-800 flex items-center text-sm uppercase tracking-widest">
                                <CreditCard className="h-5 w-5 mr-2 text-slate-500"/> Lisans ve Krediler
                              </h3>
                              {user.isPremium ? (
                                 <span className="bg-gradient-to-r from-amber-400 to-orange-500 text-white text-[11px] font-black px-3 py-1.5 rounded-full shadow-sm flex items-center w-fit">
                                   <Star className="h-3 w-3 mr-1 fill-current"/> PREMIUM AKTİF
                                 </span>
                              ) : (
                                 <span className="bg-slate-100 text-slate-600 border border-slate-200 text-[11px] font-bold px-3 py-1.5 rounded-full w-fit">
                                   STANDART PAKET
                                 </span>
                              )}
                           </div>
                           
                           {user.isPremium ? (
                              <div className="bg-gradient-to-br from-slate-900 to-indigo-950 p-6 md:p-8 rounded-2xl border border-indigo-900 shadow-xl mb-6 relative overflow-hidden flex items-center justify-between">
                                 <div className="absolute top-0 right-0 -mt-4 -mr-4 text-white/5 pointer-events-none">
                                    <Star className="h-40 w-40 fill-current"/>
                                 </div>
                                 <div className="relative z-10 pr-4">
                                    <h4 className="text-amber-400 font-bold text-xs uppercase tracking-widest mb-1.5 flex items-center"><Sparkles className="h-4 w-4 mr-2"/> VIP Lisans Aktif</h4>
                                    <p className="text-white font-black text-xl md:text-2xl leading-tight">Tüm Psikolojik Envanterler</p>
                                    <p className="text-indigo-200 text-[11px] font-medium mt-2 leading-relaxed max-w-sm">
                                      Bireysel testler, yapay zeka analizleri, toplu kurumsal raporlar ve dergi çıktıları dâhil tüm sistem özelliklerine sınırsız erişim hakkınız bulunmaktadır.
                                    </p>
                                 </div>
                                 <div className="relative z-10 flex flex-col items-center justify-center bg-white/10 backdrop-blur-md px-6 py-4 rounded-2xl border border-white/10 shadow-inner shrink-0">
                                    <span className="text-5xl font-black text-amber-400 leading-none drop-shadow-md">∞</span>
                                    <span className="text-[10px] text-amber-200 font-bold uppercase tracking-widest mt-1.5">Sınırsız</span>
                                 </div>
                              </div>
                           ) : (
                              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                                 {user.credits && Object.entries(user.credits).map(([key, val]) => (
                                    <div key={key} className="bg-slate-50 p-4 rounded-2xl border border-slate-100 flex flex-col items-center justify-center text-center shadow-sm hover:border-blue-200 transition-colors">
                                       <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">{key.replace(/_/g, ' ')}</span>
                                       <span className={`text-3xl font-black ${val > 0 ? 'text-blue-600' : 'text-red-500'}`}>
                                         {val}
                                       </span>
                                    </div>
                                 ))}
                              </div>
                           )}

                           {!user.isPremium && (
                              <div className="p-5 bg-gradient-to-br from-purple-50 to-indigo-50 rounded-2xl border border-purple-100 flex flex-col sm:flex-row items-center justify-between gap-4">
                                 <div>
                                    <h4 className="font-bold text-purple-900 text-sm">Limitlere Takılmayın</h4>
                                    <p className="text-[11px] text-purple-700 mt-1 font-medium leading-relaxed">Tüm testlerde sınırsız analiz, kurumsal raporlama ve özel özellikler için Premium'a geçiş yapın.</p>
                                 </div>
                                 <button onClick={() => setView('pricing')} className="w-full sm:w-auto px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-bold text-sm transition-all shadow-lg shadow-purple-200 flex items-center justify-center shrink-0">
                                    <Sparkles className="h-4 w-4 mr-2"/> Premium İncele
                                 </button>
                              </div>
                           )}
                        </div>

                        {/* Sistem Tercihleri */}
                        <div className="bg-white p-6 md:p-8 rounded-3xl border border-slate-200 shadow-sm">
                           <h3 className="font-bold text-slate-800 mb-5 flex items-center text-sm uppercase tracking-widest border-b border-slate-100 pb-3">
                             <Settings className="h-5 w-5 mr-2 text-slate-500"/> Sistem Tercihleri
                           </h3>
                           
                           <div className="space-y-3">
                              {/* Tema Ayarı */}
                              <div className="flex items-center justify-between p-4 bg-slate-50 rounded-2xl border border-slate-100 transition">
                                 <div className="flex items-center">
                                    <div className="h-10 w-10 bg-white rounded-xl shadow-sm border border-slate-200 flex items-center justify-center mr-4 text-slate-600">
                                      <Lightbulb className="h-5 w-5"/>
                                    </div>
                                    <div>
                                       <p className="font-bold text-slate-800 text-sm">Karanlık Mod (Dark Mode)</p>
                                       <p className="text-[11px] text-slate-500 font-medium mt-0.5">Arayüz temasını göz yormayan renklere çevirin.</p>
                                    </div>
                                 </div>
                                 <span className="bg-blue-100 text-blue-700 border border-blue-200 text-[9px] font-black px-2.5 py-1 rounded uppercase tracking-widest">
                                   Yakında
                                 </span>
                              </div>

                              {/* Bildirim Ayarı */}
                              <div className="flex items-center justify-between p-4 bg-slate-50 rounded-2xl border border-slate-100 transition">
                                 <div className="flex items-center">
                                    <div className="h-10 w-10 bg-white rounded-xl shadow-sm border border-slate-200 flex items-center justify-center mr-4 text-slate-600">
                                      <Megaphone className="h-5 w-5"/>
                                    </div>
                                    <div>
                                       <p className="font-bold text-slate-800 text-sm">E-posta Bildirimleri</p>
                                       <p className="text-[11px] text-slate-500 font-medium mt-0.5">Yeni öğrenci analizleri geldiğinde haber ver.</p>
                                    </div>
                                 </div>
                                 {/* iOS Tarzı Mock Toggle */}
                                 <div className="w-12 h-6 bg-blue-500 rounded-full relative cursor-pointer shadow-inner">
                                    <div className="w-5 h-5 bg-white rounded-full absolute right-0.5 top-0.5 shadow-sm border border-slate-100"></div>
                                 </div>
                              </div>
                           </div>
                        </div>

                     </div>
                  </div>
                </div>
              )}

                {/* YENİ: SÜPER ADMİN PANELİ EKRANI */}
                {view === 'admin-panel' && <AdminPanel />}

              {/* YENİ: FİYATLANDIRMA / SATIŞ SAYFASI BAĞLANTISI */}
              {view === 'pricing' && (
                <PricingPage 
                  onBack={() => setView('dashboard')} 
                  onUpgradeClick={() => {
                    alert("👑 PREMIUM ÜYELİK İŞLEMLERİ\n\nAşağıdaki hesap bilgilerine ödemenizi Havale/EFT yoluyla yapabilirsiniz:\n\n👤 Alıcı: [SİNAN AZAK]\n🏦 IBAN: TR09 0006 7010 0000 0015 6013 19 \n\n📌 ÖNEMLİ: Dekontunuzu gönderirken açıklama kısmına Uzman Kodunuzu (Size özel verilen 4 haneli rakam) yazmayı unutmayınız. Hesabınız gün içinde aktif edilecektir.\n\n📱 Instagram: @rehber_360\n📧 E-posta: destek@rehber360.net");
                  }} 
                />
              )}

            </> 
          )}
          {user.role === 'student' && ( 
            <> 
              {view === 'student-dashboard' && <StudentDashboard user={user} onSubmit={onPlanSubmit} />}
              {view === 'student-planner' && <StudentPlanner user={user} onSubmit={onPlanSubmit} />} 
              {view === 'student-knowledge' && <KnowledgeBase />} 
             {view === 'student-tests' && ( 
                <div className="space-y-6"> 
                  <h2 className="text-3xl font-black text-slate-800">Envanterlerim</h2> 
                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {AVAILABLE_TESTS.map(t => (
                      <div key={t.id} onClick={() => handleStartTest(t)} className="bg-white p-6 rounded-3xl border border-slate-200 hover:border-blue-500 hover:shadow-lg transition cursor-pointer group flex flex-col">
                        <div className="h-12 w-12 bg-blue-50 rounded-2xl flex items-center justify-center text-blue-600 mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors">
                          <Activity className="h-6 w-6"/>
                        </div>
                        <h3 className="text-lg font-bold text-slate-900">{t.name}</h3>
                        <p className="text-sm text-slate-500 mt-2 mb-4">{t.description}</p>
                        
                        {/* YENİ EKLENEN: ZARİF REFERANS/ATIF BÖLÜMÜ */}
                        {t.reference && (
                            <p className="text-[10px] text-slate-400 italic mb-4 border-t border-slate-100 pt-3 leading-relaxed">
                                {t.reference}
                            </p>
                        )}
                        
                        <button className="mt-auto text-xs font-bold text-blue-600 flex items-center">
                          Başla <ChevronRight className="h-3 w-3 ml-1"/>
                        </button>
                      </div>
                    ))}
                  </div> 
                </div> 
              )}
              {view === 'test-form' && activeTest && (
                /* EĞER AÇILAN TEST RİBA İSE YENİ EKRANI (RibaSurvey) AÇ */
                activeTest.id.includes('riba') ? (
                  <RibaSurvey 
                    questions={activeTest.questions} 
                    title={activeTest.name} 
                    onSubmit={async (finalData) => { 
                      try {
                        await onPlanSubmit({ 
  id: Date.now(),
  studentClass: user.class,
  studentNo: user.no,
  studentName: user.fullName || '',
  clinicianCode: user.clinicianCode,
  testId: activeTest.id,
  testName: activeTest.name,
  answers: finalData,
  status: 'pending'
});
                        
                     // 🚀 SİHİRLİ DOKUNUŞ: Arka planda anında risk hesapla
                        const result = calculateUniversalScore(finalData, activeTest.id); 
                        let rLevel = 'medium';
                        if (result) {
                            if (result.masterRisk) {
                                rLevel = result.masterRisk; 
                            } else {
                                const isRed = result.summary?.includes('KIRMIZI') || result.riskLevel === 'high';
                                if (isRed) rLevel = 'high';
                            }
                        }
                        setStudentRiskLevel(rLevel);
                        setStudentFeedbackData(result?.studentFeedback || null);

                        setView('student-success'); 
                      } catch (error) {
                        alert("⚠️ BAĞLANTI HATASI!\n\nOkul interneti (Wi-Fi) engelliyor olabilir. Lütfen hücresel veriye geçin.");
                      }
                    }} 
                    onBack={() => setView('student-tests')} 
                  />
                ) : (
                  /* DEĞİLSE ESKİ KLASİK TEST EKRANINI (TestForm) AÇ */
                  <TestForm 
                    test={activeTest} 
                    user={user} 
                    onSubmit={async (ans, options = {}) => { 
                      try {
                       const saveSuccess = await onPlanSubmit({
  id: Date.now(),
  studentClass: user.class,
  studentNo: user.no,
  studentName: user.fullName || '',
  clinicianCode: user.clinicianCode,
  testId: activeTest.id,
  testName: activeTest.name,
  answers: ans,
  status: 'pending'
}, options);

// Kayıt başarısızsa başarı ekranına geçme.
if (saveSuccess !== true) {
  alert(
    "⚠️ Kayıt tamamlanamadı.\n\n" +
    "Cevaplarınız korunuyor. Lütfen bağlantınızı kontrol edip tekrar deneyin."
  );
  return false;
}
                        
                       // 🚀 SİHİRLİ DOKUNUŞ: Arka planda anında risk hesapla
                        const result = calculateUniversalScore(ans, activeTest.id); // RibaSurvey için finalData yazılıydı, onu bozma
                        let rLevel = 'medium';
                        if (result) {
                            // 🚀 YENİ VE KUSURSUZ YÖNTEM: Riski motordan (masterRisk) hazır al!
                            if (result.masterRisk) {
                                rLevel = result.masterRisk; 
                            } else {
                                // Eğer eski bir testse ve masterRisk yoksa, yedek/eski usul okuma yap
                                const isRed = result.summary?.includes('KIRMIZI') || result.riskLevel === 'high';
                                if (isRed) rLevel = 'high';
                            }
                        }
                        setStudentRiskLevel(rLevel);

if (options.skipStudentFeedback) {

  // Holland gibi kendi özel sonuç ekranını zaten göstermiş testlerde
  // ikinci bir sonuç ekranı açma.
  setStudentFeedbackData(null);
  setView('student-tests');

} else {

  // Özel sonuç ekranı olmayan testler normal StudentFeedbackUI'a gider.
  setStudentFeedbackData(result?.studentFeedback || null);
    setView('student-success');

}

                        return true;

                      } catch (error) {

                        console.error(
                          "Envanter kayıt hatası:",
                          error
                        );

                        alert(
                          "⚠️ Kayıt tamamlanamadı.\n\n" +
                          "Cevaplarınız korunuyor. Lütfen tekrar deneyin."
                        );

                        return false;
                      }
                    }}
                    onCancel={() => setView('student-tests')} 
                  />
               )
              )}
              
              {/* YENİ ŞEFKATLİ ÖĞRENCİ GERİ BİLDİRİM EKRANI */}
{view === 'student-success' && (
  <StudentFeedbackUI 
    studentName={user.fullName || "Öğrencimiz"} 
    studentNo={user.no}
    testId={activeTest?.id || ""}
    riskLevel={studentRiskLevel}
    studentFeedback={studentFeedbackData}
    onReturnHome={() => window.location.reload()} 
  />
)}
            </> 
          )}

          {/* YENİ EKLENEN: RESMİ VE ETİK FERAGATNAME (UYARI) KUTUSU */}
          <div className="mt-8 pt-6 border-t-2 border-dashed border-slate-200 print:mt-4 print:pt-4">
             <div className="bg-slate-50 border border-slate-200 p-4 rounded-xl flex items-start gap-4 print:bg-white print:border-slate-300">
                <div className="h-10 w-10 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 print:bg-slate-100 print:text-slate-600">
                   <AlertTriangle className="h-5 w-5"/>
                </div>
                <div>
                   <h4 className="font-bold text-slate-800 text-xs uppercase tracking-widest mb-1">Önemli Yasal ve Etik Uyarı</h4>
                   <p className="text-[11px] print:text-[10px] text-slate-600 font-medium leading-relaxed text-justify">
                      Bu rapor bir <strong>tıbbi tanı (teşhis) aracı değildir.</strong> Okul rehberlik servisi tarafından öğrencinin gelişimini desteklemek amacıyla gerçekleştirilen <em>Psikososyal Ön Değerlendirme ve Risk Tarama</em> analizidir. Kesin tıbbi tanı ve tedavi süreçleri için mutlaka bir <strong>Çocuk ve Ergen Ruh Sağlığı ve Hastalıkları Uzmanına (Psikiyatrist)</strong> başvurulmalıdır.
                   </p>
                </div>
             </div>
          </div>

          {/* SİHİRLİ GİZLİ ALAN: TOPLU PDF ÇİZİM MOTORU */}
          {isBulkPrinting && bulkPrintData && (
              <div className="absolute top-[-9999px] left-[-9999px] opacity-0" aria-hidden="true">
                  <div id="hidden-bulk-print-area" className="w-[210mm] bg-white text-black">
                      {bulkPrintData.map((sub) => {
                          const testId = sub.testId;
                          return (
                              <div key={sub.id} className="page-break p-8">
                                  {testId === 'basarisizlik_nedenleri' || testId?.includes('basarisizlik') ? <BasarisizlikReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'ogrenci_bilgi_formu' || testId?.includes('bilgi_formu') ? <StudentInfoReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'devamsizlik_nedenleri' || testId?.includes('devamsizlik') ? <DevamsizlikReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'sinav_kaygisi' || testId?.includes('sinav') ? <SinavKaygisiReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'internet_bagimliligi' || testId?.includes('bagimlilik') ? <InternetBagimliligiReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'rosenberg_benlik_saygisi' ? <RosenbergReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'mesleki_degerler_envanteri' || testId?.includes('degerler') ? <MeslekiDegerlerReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'asrs_form' ? <AsrsReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'kariyer_pusulasi' ? <KariyerPusulasiReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'snap_iv_form' ? <SnapIVReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'dass_21' ? <Dass21ReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'beck_anksiyete' || testId?.includes('beck') ? <BeckAnksiyeteReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'mesleki_egilim_belirleme' ? <MeslekiEgilimReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'vak_inventory' || testId?.includes('vak') ? <VakReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'yasam_pencerem' || testId?.includes('yasam') ? <YasamPenceremReportUI data={sub.reportData} meta={sub} /> :
                                   testId === 'lgs_pusulasi' || testId?.includes('lgs') ? <LgsPusulasiReportUI submission={sub} /> :
                                   testId === 'coklu_zeka_envanteri' || testId?.includes('coklu_zeka') ? <CokluZekaReportUI data={sub.reportData} meta={sub} /> :
                                   <div className="p-10 text-center font-bold">Bu test için bireysel baskı şablonu bulunamadı.</div>
                                  }
                              </div>
                          );
                      })}
                  </div>
              </div>
          )}

        </div> 
      </div> 
    </div> 
  ); 
};

// --- YENİ BİLEŞEN: E-POSTA DOĞRULAMA EKRANI (BOT KORUMALI) ---
const EmailVerificationPage = ({ actionCode, onBackToLogin }) => {
  const [status, setStatus] = useState('idle'); // idle, verifying, success, error
  const [errorMessage, setErrorMessage] = useState('');

  const handleVerify = () => {
    if (!actionCode) {
      setStatus('error');
      setErrorMessage("Güvenlik kodu bulunamadı.");
      return;
    }

    setStatus('verifying');
    applyActionCode(auth, actionCode)
      .then(() => {
        setStatus('success');
      })
      .catch((error) => {
        console.error("Doğrulama Hatası:", error);
        setStatus('error');
        setErrorMessage("Bağlantı geçersiz veya hesabınız zaten doğrulanmış olabilir. Lütfen sisteme giriş yapmayı deneyin.");
      });
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4 relative overflow-hidden">
       <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-emerald-400/20 blur-[120px] rounded-full pointer-events-none"></div>
       <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-teal-400/20 blur-[120px] rounded-full pointer-events-none"></div>

      <div className="bg-white w-full max-w-md rounded-3xl p-8 shadow-2xl border border-slate-100 z-10 relative text-center">
        
        {/* BAŞLANGIÇ EKRANI: Buton burada! */}
        {status === 'idle' && (
          <div className="py-4 animate-in fade-in duration-300">
            <div className="h-16 w-16 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm border border-blue-100">
              <MailCheck className="h-8 w-8" />
            </div>
            <h2 className="text-2xl font-black text-slate-800 mb-2">E-posta Doğrulama</h2>
            <p className="text-sm text-slate-500 mb-8 leading-relaxed">Hesabınızı aktifleştirmek ve güvenle giriş yapmak için aşağıdaki butona tıklayın.</p>
            <button onClick={handleVerify} className="px-6 py-4 bg-blue-600 text-white rounded-xl font-bold text-sm hover:bg-blue-700 transition shadow-lg shadow-blue-200 w-full flex items-center justify-center">
              Hesabımı Doğrula
            </button>
          </div>
        )}

        {status === 'verifying' && (
          <div className="flex flex-col items-center justify-center py-8">
            <Loader2 className="h-10 w-10 text-emerald-600 animate-spin mb-4" />
            <h2 className="text-xl font-black text-slate-800 mb-2">E-posta Doğrulanıyor</h2>
            <p className="text-sm font-medium text-slate-500">Lütfen bekleyin, güvenliğiniz sağlanıyor...</p>
          </div>
        )}

        {status === 'error' && (
          <div className="py-6 animate-in zoom-in duration-300">
            <div className="bg-red-50 text-red-600 p-4 rounded-xl border border-red-100 mb-6">
              <AlertTriangle className="h-8 w-8 mx-auto mb-2" />
              <p className="text-sm font-bold">{errorMessage}</p>
            </div>
            <button onClick={onBackToLogin} className="px-6 py-3 bg-slate-900 text-white rounded-xl font-bold text-sm hover:bg-slate-800 transition shadow-lg w-full">
              Giriş Ekranına Dön
            </button>
          </div>
        )}

        {status === 'success' && (
          <div className="py-6 animate-in zoom-in duration-300">
            <div className="h-20 w-20 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner border border-emerald-200">
              <CheckCircle className="h-10 w-10" />
            </div>
            <h3 className="text-2xl font-black text-slate-800 mb-2">Hesabınız Onaylandı!</h3>
            <p className="text-sm text-slate-500 mb-8 leading-relaxed">E-posta adresiniz başarıyla doğrulandı. Artık Rehber360'ın tüm özelliklerini güvenle kullanabilirsiniz.</p>
            <button onClick={onBackToLogin} className="px-6 py-4 bg-emerald-600 text-white rounded-xl font-bold text-sm hover:bg-emerald-700 transition shadow-lg shadow-emerald-200 w-full flex items-center justify-center">
              Sisteme Giriş Yap <ChevronRight className="h-4 w-4 ml-2" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// --- YENİ BİLEŞEN: ŞİFRE SIFIRLAMA (RESET PASSWORD) EKRANI ---
const ResetPasswordPage = ({ actionCode, onBackToLogin }) => {
  const [newPassword, setNewPassword] = useState('');
  const [status, setStatus] = useState('verifying'); // verifying, ready, success, error
  const [errorMessage, setErrorMessage] = useState('');
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    // 1. ZIRH: Hotmail Botu mu, Gerçek İnsan mı?
    // Sayfa açılır açılmaz Firebase'e soruyoruz: "Bu kod hala geçerli mi?"
    if (actionCode) {
      verifyPasswordResetCode(auth, actionCode)
        .then((email) => {
          // Kod geçerli! Bot tüketmemiş. Gerçek insan burada.
          setUserEmail(email);
          setStatus('ready');
        })
        .catch((error) => {
          // Kod kullanılmış veya süresi dolmuş! (Bot yemiş olabilir)
          console.error("Geçersiz Kod:", error);
          setStatus('error');
          setErrorMessage("Bu şifre sıfırlama bağlantısı geçersiz, kullanılmış veya süresi dolmuş. Lütfen tekrar şifre sıfırlama talebinde bulunun.");
        });
    } else {
      setStatus('error');
      setErrorMessage("Güvenlik kodu bulunamadı.");
    }
  }, [actionCode]);

  const handleReset = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      alert("Şifreniz en az 6 karakter olmalıdır.");
      return;
    }

    try {
      setStatus('verifying');
      // 2. ZIRH: Yeni şifreyi Firebase'e gönder ve kaydet
      await confirmPasswordReset(auth, actionCode, newPassword);
      setStatus('success');
    } catch (error) {
      setStatus('error');
      setErrorMessage("Şifre güncellenirken bir hata oluştu: " + error.message);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4 relative overflow-hidden">
       {/* Arkaplan Süslemeleri */}
       <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-400/20 blur-[120px] rounded-full pointer-events-none"></div>
       <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-indigo-400/20 blur-[120px] rounded-full pointer-events-none"></div>

      <div className="bg-white w-full max-w-md rounded-3xl p-8 shadow-2xl border border-slate-100 z-10 relative">
        <div className="text-center mb-8">
          <div className="h-16 w-16 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-sm border border-blue-100">
            <Lock className="h-8 w-8"/>
          </div>
          <h2 className="text-2xl font-black text-slate-800">Şifre Yenileme</h2>
          <p className="text-sm text-slate-500 mt-2">Rehber360 hesabınız için yeni bir şifre belirleyin.</p>
        </div>

        {status === 'verifying' && (
          <div className="flex flex-col items-center justify-center py-8">
            <Loader2 className="h-8 w-8 text-blue-600 animate-spin mb-4" />
            <p className="text-sm font-bold text-slate-600">Bağlantı Güvenliği Doğrulanıyor...</p>
          </div>
        )}

        {status === 'error' && (
          <div className="text-center py-6">
            <div className="bg-red-50 text-red-600 p-4 rounded-xl border border-red-100 mb-6">
              <AlertTriangle className="h-6 w-6 mx-auto mb-2" />
              <p className="text-sm font-bold">{errorMessage}</p>
            </div>
            <button onClick={onBackToLogin} className="px-6 py-3 bg-slate-900 text-white rounded-xl font-bold text-sm hover:bg-slate-800 transition shadow-lg w-full">
              Giriş Ekranına Dön
            </button>
          </div>
        )}

        {status === 'success' && (
          <div className="text-center py-6 animate-in zoom-in duration-300">
            <div className="h-16 w-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="h-8 w-8" />
            </div>
            <h3 className="text-xl font-black text-slate-800 mb-2">Şifreniz Yenilendi!</h3>
            <p className="text-sm text-slate-500 mb-6">Yeni şifrenizle sisteminize güvenle giriş yapabilirsiniz.</p>
            <button onClick={onBackToLogin} className="px-6 py-3 bg-blue-600 text-white rounded-xl font-bold text-sm hover:bg-blue-700 transition shadow-lg shadow-blue-200 w-full flex items-center justify-center">
              Hemen Giriş Yap <ChevronRight className="h-4 w-4 ml-2" />
            </button>
          </div>
        )}

        {status === 'ready' && (
          <form onSubmit={handleReset} className="space-y-5 animate-in fade-in duration-500">
            <div className="bg-slate-50 p-3 rounded-xl border border-slate-200 flex items-center text-sm text-slate-600 mb-2">
              <User className="h-4 w-4 mr-2 opacity-50" />
              <span className="font-medium truncate">{userEmail}</span>
            </div>
            
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
              <input 
                type="password" 
                required 
                placeholder="Yeni Şifreniz (En az 6 karakter)" 
                value={newPassword} 
                onChange={(e) => setNewPassword(e.target.value)} 
                className="w-full pl-12 pr-4 py-4 rounded-xl border border-slate-200 text-sm font-medium focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition bg-slate-50 focus:bg-white"
              />
            </div>
            <button type="submit" className="w-full py-4 bg-slate-900 text-white rounded-xl font-bold text-sm hover:bg-slate-800 transition shadow-lg flex items-center justify-center">
              <Save className="h-4 w-4 mr-2" /> Şifremi Güncelle
            </button>
          </form>
        )}
      </div>
      
      {/* Footer */}
      <div className="absolute bottom-6 text-xs font-bold text-slate-400">
        Rehber360 Güvenli Giriş Sistemi
      </div>
    </div>
  );
};

// --- APP ---
// --- APP ---
const App = () => { 
  const [view, setView] = useState('landing'); 
  const [user, setUser] = useState(null); 
  const [submissions, setSubmissions] = useState([]); 

  const [academicYear, setAcademicYear] = useState(() => {
    const savedYear = localStorage.getItem('rehber360_academicYear');

    return ACADEMIC_YEARS.includes(savedYear)
      ? savedYear
      : ACTIVE_ACADEMIC_YEAR;
  });

  useEffect(() => {
    localStorage.setItem('rehber360_academicYear', academicYear);
  }, [academicYear]);

  const [report, setReport] = useState(null); 
  const [loading, setLoading] = useState(false); 
  const [pendingTestId, setPendingTestId] = useState(null); 
  const [pendingRefCode, setPendingRefCode] = useState(null);
  const [pendingUid, setPendingUid] = useState(null);

  const [globalModal, setGlobalModal] = useState({ 
    isOpen: false,
    type: 'confirm',
    title: '',
    message: '',
    confirmText: '',
    onConfirm: null 
  });

  const closeGlobalModal = () => setGlobalModal(prev => ({ ...prev, isOpen: false }));
  
// YENİ: TÜM ALT BİLEŞENLERE GÖNDERİLECEK EVRENSEL TETİKLEYİCİ
  const triggerModal = (options) => {
    setGlobalModal({ isOpen: true, ...options });
  };

  // YENİ EKLENEN: Şifre Sıfırlama Kodu için State
  const [resetActionCode, setResetActionCode] = useState(null); 
  const [lastDoc, setLastDoc] = useState(null); // Sayfalamada nerede kaldığımızı tutar
  const [hasMore, setHasMore] = useState(true); // Veritabanında çekilecek başka veri kaldı mı?

  // --- YENİ EKLENEN: F5'E DAYANIKLI GİRİŞ VE ÇIKIŞ MOTORLARI ---
  const handleLoginSuccess = (loggedInUser, targetView) => {
    setUser(loggedInUser); 
    setView(targetView);   
    
    localStorage.setItem('rehber360_user', JSON.stringify(loggedInUser));
    localStorage.setItem('rehber360_view', targetView);
  };

  const handleLogout = () => {
    setUser(null);
    setView('landing');
    setPendingTestId(null);
    setPendingRefCode(null);
    
    // TARAYICI HAFIZASINI TEMİZLE (Başkası F5 yapıp giremesin)
    localStorage.removeItem('rehber360_user');
    localStorage.removeItem('rehber360_view');
  };
  // -----------------------------------------------------------

 // 1. ZIRHLI VE TEK SEFERLİK VERİ ÇEKME MOTORU (TÜM OKUL VERİSİ)
  const fetchSubmissionsOnDemand = async (currentUser) => {
    if (!currentUser) return;
    const targetUid = currentUser.role === 'specialist' ? currentUser.uid : currentUser.clinicianUid;
    if (!targetUid) return;

    setLoading(true); 
    
    try {
      // 🚨 limit(50) kaldırıldı. Çünkü Dashboard ve Okul Raporlarının TÜM veriye ihtiyacı var.
      const q = query(
        collection(db, "submissions"),
        where("clinicianUid", "==", targetUid),
        orderBy("timestamp", "desc") 
      );

      
      const snapshot = await getDocs(q); 
            
      const fetchedData = snapshot.docs.map(doc => ({ ...doc.data(), firebaseId: doc.id, id: doc.id }));
      setSubmissions(fetchedData);

    } catch (error) {
      console.error("Veri çekme hatası:", error);
      alert("Veriler çekilirken bir hata oluştu: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // 2. İHTİYAÇ ANINDA PANELLERİ TAZELEMEK İÇİN
  const handleRefreshData = () => {
    fetchSubmissionsOnDemand(user);
  };

// 🚀 İŞTE YENİ KODU TAM BURAYA EKLİYORUZ
  const handleLocalDelete = (deletedId) => {
    setSubmissions(prev => prev.filter(sub => (sub.firebaseId || sub.id) !== deletedId));
  };

  // 3. SİSTEME İLK GİRİŞTE VERİYİ SADECE 1 KERE ÇEK (SADECE UZMANLAR İÇİN)
  useEffect(() => {
    // 🛡️ SİHİRLİ DOKUNUŞ: Öğrenciler sadece veri yollar, veri çekemezler!
    // Bu yüzden sadece sisteme giren kişi 'specialist' (Uzman) ise veritabanını indir.
    if (user && user.role === 'specialist' && user.uid) {
      fetchSubmissionsOnDemand(user);
    }
  }, [user]);

  // QR KODDAN GELENLERİ YAKALAMA, ŞİFRE SIFIRLAMA VE F5 UYANIŞ SİSTEMİ
  useEffect(() => { 
    const params = new URLSearchParams(window.location.search); 
    
    // URL Parametrelerini Yakala
    let testId = params.get('test'); 
    const refCode = params.get('ref'); 
    const uidCode = params.get('uid'); 
    const mode = params.get('mode');
    const actionCode = params.get('oobCode');

    // 1. DURUM: EĞER KULLANICI ŞİFRE SIFIRLAMA MAİLİNDEN GELDİYSE
    if (mode === 'resetPassword' && actionCode) {
        setResetActionCode(actionCode);
        setView('reset-password'); 
    } 
// YENİ EKLENEN DURUM: E-POSTA DOĞRULAMA MAİLİNDEN GELDİYSE
    else if (mode === 'verifyEmail' && actionCode) {
        setResetActionCode(actionCode); // Aynı state'i kod tutmak için kullanabiliriz
        setView('verify-email');
    }
    // 2. DURUM: EĞER ÖĞRENCİ TEST ÇÖZMEYE GELDİYSE (QR KOD / LİNK)
    else if (testId) { 
        // SİHİRLİ DOKUNUŞ: Linkin sonuna yapışan slash (/) ve boşlukları sistemin içine girmeden kapıda imha ediyoruz!
        testId = testId.replace(/[\/\s]/g, '');
        
        setPendingTestId(testId); 
        if (refCode) setPendingRefCode(refCode); 
        if (uidCode) setPendingUid(uidCode); 
        setView('participant-login'); 
    } 
    // 3. DURUM: NORMAL GİRİŞ VEYA F5 (SAYFA YENİLEME)
    else {
        // F5 Uyanış Sistemi ve Firebase Senkronizasyonu
        const savedUser = localStorage.getItem('rehber360_user');
        const savedView = localStorage.getItem('rehber360_view');
        
      // 🛡️ KRİTİK KONTROL: Firebase bizi hatırlıyor mu? Hatırlamıyorsa (Tarayıcı kapanmışsa) içeri alma!
      const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
          // Mevcut kayıtlı kullanıcıyı ve görünümü al
          const savedUser = localStorage.getItem('rehber360_user');
          const savedView = localStorage.getItem('rehber360_view');
          const parsedUser = savedUser ? JSON.parse(savedUser) : null;

          // 🌟 SİHİRLİ DOKUNUŞ: Öğrenci ise Firebase Auth onayı bekleme (Çünkü e-posta ile girmediler), direkt içeri al!
          if (parsedUser && parsedUser.role === 'student' && savedView) {
              setUser(parsedUser);
              setView(savedView);
          } 
          // Uzman (PDR) ise Firebase Auth onayı (firebaseUser) ŞART! Yoksa at.
          else if (firebaseUser && parsedUser && savedView) {
              setUser(parsedUser);
              setView(savedView);
          } else {
              // SİHİRLİ ZIRH: Eğer şu özel kapı görünümlerinden birindeysek, sakın yerimizden kıpırdatma!
              const currentView = view || savedView;
              const safeViews = ['register', 'participant-login', 'reset-password', 'verify-email', 'awaiting-verification', 'clinician-login'];
              
              if (!safeViews.includes(currentView)) {
                  localStorage.removeItem('rehber360_user');
                  localStorage.removeItem('rehber360_view');
                  setUser(null);
                  setView('landing');
              }
          }
      });

        // Dinleyiciyi temizle
        return () => unsubscribe();
    }
  }, []);
  const handlePlanSubmit = async (planData, options = {}) => { 
    

    // 1. ZIRH: Uzman UID'sini bulmaya çalış
    let uidToSave = user.role === 'specialist' ? user.uid : (user.clinicianUid || planData.clinicianUid);

    // 2. ZIRH (HAYAT KURTARAN YER): Öğrenci hesabında UID eksikse, PDR Kodundan (Örn: 7335) gerçek UID'yi Firebase'den zorla bul!
    if (!uidToSave && planData.clinicianCode) {
       try {
           // Firebase bazen kodu Metin (String) bazen Sayı (Number) kaydeder. İkisine de bakıyoruz!
           let q = query(collection(db, "users"), where("refCode", "==", String(planData.clinicianCode)));
           let snap = await getDocs(q);
           
           if (snap.empty) {
               q = query(collection(db, "users"), where("refCode", "==", Number(planData.clinicianCode)));
               snap = await getDocs(q);
           }
           
           if (!snap.empty) {
               uidToSave = snap.docs[0].id; // Senin gerçek Firebase gizli kimliğin
               console.log("✅ Eksik UID başarıyla kurtarıldı:", uidToSave);
           }
       } catch(e) {
           console.error("❌ UID Kurtarma Hatası:", e);
       }
    }

    // Eğer her şeye rağmen UID bulunamazsa işlemi durdur (Boşluğa veri gitmesin)
  if (!uidToSave) {
    alert(
      "⚠️ Kritik Hata: Uzman kimliği (UID) sistemde bulunamadı. " +
      "Lütfen uzman kodunuzu kontrol edin."
    );

    return false;
}

    const finalPlanData = {
        ...planData,
        clinicianUid: uidToSave
    };

    
   const saveSuccess =
  await DB.saveSubmission(
    finalPlanData
  );


if (!saveSuccess) {

  return false;
}


// Öğrenci soru girişi yapıyorsa sayfayı değiştirme
// (Modal kapanır), diğer testlerde başarı ekranına at.
if (
  user.role === 'student' &&
  planData.testId !==
    'gunluk_soru_takibi' &&
  !options.skipStudentFeedback
) {

  setView(
    'student-success'
  );
}


return true;
  };
  
const handleIndividualAnalyze = async (sub) => { 
    if (!user.isPremium) {
      const hasCredit = await DB.consumeCredit(user.uid, sub.testId);
      if (!hasCredit) {
        alert(`Bu test (${sub.testName}) için analiz hakkınız dolmuştur.\n\nDevam etmek için Premium'a geçiniz.`);
        setView('pricing'); 
        return; 
      }
      const updatedProfile = await DB.getProfile(user.uid);
      setUser(updatedProfile);
    }

    setLoading(true); 
    
    const result = calculateUniversalScore(sub.answers, sub.testId); 
    
    if (!result) {
        alert("Bu test için analiz motoru henüz yapılandırılmadı. Lütfen form ayarlarını kontrol edin.");
        setLoading(false);
        return;
    }

    // 🚀 İŞTE HAYAT KURTARAN DOKUNUŞ: MEVCUT YAPAY ZEKA ANALİZİNİ KORU!
    // Görüntüle butonuna tekrar basıldığında AI analizinin silinmesini (ezilmesini) engeller.
    if (sub.reportData && sub.reportData.aiAnalysis) {
        result.aiAnalysis = sub.reportData.aiAnalysis;
    }
    // (Eğer RİBA gibi ekstra mülakat verileri varsa onları da silinmekten kurtar)
    if (sub.reportData && sub.reportData.userSelections) {
        result.userSelections = sub.reportData.userSelections;
    }

        const updatedSub = {
      ...sub,
      status: 'reported',
      reportData: result
    };

    const saveSuccess =
      await DB.saveSubmission(updatedSub);


    if (!saveSuccess) {
      alert(
        "⚠️ Analiz hesaplandı ancak veritabanına kaydedilemedi.\n\n" +
        "Kayıt 'Bekliyor' durumunda bırakıldı. İnternet bağlantınızı kontrol edip tekrar deneyiniz."
      );

      setLoading(false);
      return;
    }


    // Yalnız Firestore kaydı gerçekten başarılıysa
    // ekranda İncelendi durumuna geçir.
    setSubmissions(prev =>
      prev.map(s =>
        (s.firebaseId || s.id) ===
        (sub.firebaseId || sub.id)
          ? updatedSub
          : s
      )
    );

    setReport({
      type: 'individual',
      data: result,
      meta: updatedSub
    });

    setLoading(false); 
  };

 const handleBulkAnalyze = async (subsToAnalyze) => {
    if (subsToAnalyze.length === 0) return;
    
    setGlobalModal({
      isOpen: true,
      type: 'confirm',
      title: 'Toplu Yapay Zeka Analizi',
      message: `Ekranda listelenen ${subsToAnalyze.length} adet bekleyen veri tek tuşla hesaplanıp raporlanacak. Başlamak istiyor musunuz?`,
      confirmText: 'Evet, Başlat',
      onConfirm: async () => {
        closeGlobalModal();

        setLoading(true);
                let successCount = 0;
        let failedCount = 0;
        let outOfCredit = false;
        let updatedList = []; 

        try {
          for (const sub of subsToAnalyze) {
            if (!user.isPremium) {
              const hasCredit = await DB.consumeCredit(user.uid, sub.testId);
              if (!hasCredit) {
                outOfCredit = true;
                break; 
              }
            }

            const result = calculateUniversalScore(sub.answers, sub.testId); 
            
            if (!result) {
                console.warn(`Atlandı: ${sub.testName} için analiz motoru henüz yapılandırılmadı.`);
                continue; 
            }

            if (sub.reportData && sub.reportData.aiAnalysis) {
                result.aiAnalysis = sub.reportData.aiAnalysis;
            }
            if (sub.reportData && sub.reportData.userSelections) {
                result.userSelections = sub.reportData.userSelections;
            }

                        const updatedSub = {
              ...sub,
              status: 'reported',
              reportData: result
            };

            const saveSuccess =
              await DB.saveSubmission(updatedSub);


            if (!saveSuccess) {
              failedCount++;

              console.error(
                "Analiz kaydedilemedi:",
                sub.firebaseId || sub.id
              );

              continue;
            }


            updatedList.push(updatedSub);
            successCount++;
          }

          if (updatedList.length > 0) {
             setSubmissions(prev => prev.map(oldSub => {
                 const newlyAnalyzed = updatedList.find(ns => (ns.firebaseId || ns.id) === (oldSub.firebaseId || oldSub.id));
                 return newlyAnalyzed ? newlyAnalyzed : oldSub;
             }));
          }

          if (!user.isPremium && successCount > 0) {
              const updatedProfile = await DB.getProfile(user.uid);
              setUser(updatedProfile);
          }

                    if (outOfCredit) {

            alert(
              `⚠️ Analiz haklarınız bittiği için işlem durduruldu.\n\n` +
              `${successCount} kayıt başarıyla incelendi ve kaydedildi.` +
              (
                failedCount > 0
                  ? `\n${failedCount} kayıt kaydedilemedi.`
                  : ''
              )
            );

          } else if (failedCount > 0) {

            alert(
              `⚠️ Toplu analiz tamamlandı.\n\n` +
              `✅ ${successCount} kayıt başarıyla kaydedildi.\n` +
              `❌ ${failedCount} kayıt kaydedilemedi.\n\n` +
              `Kaydedilemeyen kayıtlar "Bekliyor" olarak bırakıldı.`
            );

          } else {

            alert(
              `⚡ Harika! ${successCount} adet öğrenci verisi başarıyla değerlendirildi ve kaydedildi.`
            );
          }
        } catch (error) {
          console.error(error);
          alert("Toplu analiz sırasında bir hata oluştu: " + error.message);
        } finally {
          setLoading(false);
        }
      } // onConfirm fonksiyonunun kapanışı
    }); // setGlobalModal kapanışı
  }; // handleBulkAnalyze fonksiyonunun kapanışı


// İŞTE BURAYA EKLİYORUZ: ZAMAN MAKİNESİ FONKSİYONU
  const handleMigrateData = async () => {
    const confirm = window.confirm("Geçmişteki tüm verilerinize (Öğrenciler, Sınıflar, Testler) UID damgası vurulacak. Onaylıyor musunuz?");
    if (!confirm) return;
    
    setLoading(true);
    try {
        const collections = ["submissions", "classes", "students"];
        const batch = writeBatch(db);
        let count = 0;

        for (const collName of collections) {
            const q = query(collection(db, collName), where("clinicianCode", "==", String(user.refCode)));
            const snapshot = await getDocs(q);
            
            snapshot.forEach(docSnap => {
                if (!docSnap.data().clinicianUid) {
                    batch.update(docSnap.ref, { clinicianUid: user.uid });
                    count++;
                }
            });
        }

        if (count > 0) {
            await batch.commit();
            alert(`🚀 HARİKA! Toplam ${count} eski kayda başarıyla UID damgası vuruldu! Artık çelik kapıyı takabiliriz.`);
        } else {
            alert("✅ Güncellenecek eski kayıt bulunamadı (Tüm veriler zaten damgalı).");
        }
    } catch (error) {
        console.error(error);
        alert("Hata oluştu: " + error.message);
    } finally {
        setLoading(false);
    }
  };
  
// YENİ EKLENEN: Yapay Zeka Analizi Sonrası Ekranı Güncel Tutan Köprü
  const handleUpdateReportData = async (updatedSubmission) => {
    try {
      // 1. Veritabanına (Firebase) kaydet
      await DB.saveSubmission(updatedSubmission);
      
      // 2. Arka plandaki öğrenci listesini (submissions) anında güncelle
      setSubmissions(prev => prev.map(s => 
        (s.firebaseId || s.id) === (updatedSubmission.firebaseId || updatedSubmission.id) ? updatedSubmission : s
      ));

      // 3. O an açık olan penceredeki veriyi (report) güncelle
      setReport(prev => ({ 
        ...prev, 
        meta: updatedSubmission, 
        data: updatedSubmission.reportData 
      }));
      
    } catch (error) {
      console.error("Rapor güncellenirken hata oluştu:", error);
    }
  };

  return (
    <div className="font-sans text-slate-900 bg-white App">
      <PrintStyles />
      {loading && <div className="fixed inset-0 bg-white/80 z-[100] flex items-center justify-center backdrop-blur-sm"><Loader2 className="h-12 w-12 text-blue-600 animate-spin"/></div>}
      {view === 'landing' && !user && <LandingPage onSelect={setView} />}
      {view === 'pricing' && (
        <PricingPage 
          onBack={() => setView('dashboard')} 
          onUpgradeClick={() => alert("Buraya ödeme veya iletişim linki eklenecek!")} 
        />
      )}

{/* YENİ: ŞİFRE SIFIRLAMA EKRANI */}
      {view === 'reset-password' && (
        <ResetPasswordPage 
          actionCode={resetActionCode} 
          onBackToLogin={() => { setView('clinician-login'); window.history.replaceState({}, document.title, "/"); }} 
        />
      )}

{/* YENİ: E-POSTA DOĞRULAMA EKRANI */}
      {view === 'verify-email' && (
        <EmailVerificationPage 
          actionCode={resetActionCode} 
          onBackToLogin={() => { setView('clinician-login'); window.history.replaceState({}, document.title, "/"); }} 
        />
      )}

{/* YENİ: KAYIT SONRASI DOĞRULAMA BEKLEME EKRANI (KÜRESEL) */}
      {view === 'awaiting-verification' && (
        <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100 flex items-center justify-center p-4">
          <div className="w-full max-w-md bg-white/90 backdrop-blur-md p-10 rounded-3xl shadow-2xl border border-white/50 text-center animate-in zoom-in duration-500">
            <div className="h-20 w-20 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm border border-emerald-200">
              <MailCheck className="h-10 w-10" />
            </div>
            <h2 className="text-2xl font-black text-slate-800 mb-2">E-posta Doğrulaması Gerekli</h2>
            <p className="text-slate-600 mb-6 text-sm leading-relaxed">
              Hesabınız başarıyla oluşturuldu! Ancak güvenliğiniz için e-posta adresinize bir doğrulama bağlantısı gönderdik.
              <br/><br/>
              Lütfen e-postanızı kontrol edin ve bağlantıya tıklayarak hesabınızı aktifleştirin.
            </p>
            <button 
              onClick={() => { setView('clinician-login'); localStorage.setItem('rehber360_view', 'clinician-login'); }} 
              className="w-full py-4 bg-slate-900 hover:bg-slate-800 transition-colors text-white rounded-xl font-bold flex items-center justify-center shadow-lg"
            >
              Doğruladım, Giriş Yap
            </button>
          </div>
        </div>
      )}
      
      {/* GÜNCELLENDİ: F5 Uyumlu Öğrenci Girişi */}
     {view === 'participant-login' && (
          <ParticipantLogin 
            pendingTestId={pendingTestId} 
            pendingRefCode={pendingRefCode}
            pendingUid={pendingUid}
            onLogin={(code, cls, no, name, uid) => { 
                handleLoginSuccess({ role:'student', class:cls, no, clinicianCode:code, clinicianUid: uid, fullName: name }, 'main'); 
            }} 
            onBack={() => { setView('landing'); setPendingTestId(null); setPendingRefCode(null); setPendingUid(null); }} 
          />
      )}
      
      {/* GÜNCELLENDİ: F5 Uyumlu Uzman Girişi ve Kayıt */}
      {view === 'clinician-login' && <ClinicianLogin onLogin={(usr)=> handleLoginSuccess(usr, 'dashboard')} onSwitchToRegister={() => setView('register')} onBack={() => setView('landing')} />}
      
      {view === 'register' && <RegisterPage onRegister={(target) => setView(target)} onSwitchToLogin={() => setView('clinician-login')} onBack={() => setView('landing')} />}

      {/* GÜNCELLENDİ: F5 Uyumlu Çıkış Butonu */}
      {(user && (user.role === 'student' || user.role === 'specialist')) && (
          <MainLayout 
    user={user} 
    submissions={submissions}
    academicYear={academicYear}
    onAcademicYearChange={setAcademicYear}
    initialTestId={pendingTestId} 
    onLogout={handleLogout} 
    onAnalyze={handleIndividualAnalyze} 
    onBulkAnalyze={handleBulkAnalyze} 
    onPlanSubmit={handlePlanSubmit} 
    onMigrate={handleMigrateData} 
    onRefreshData={handleRefreshData}
    onDelete={handleLocalDelete} 
    setGlobalModal={setGlobalModal}
    closeGlobalModal={closeGlobalModal}
    triggerModal={triggerModal}
/>
      )}
      
     {report && <ReportViewer report={report} user={user} onClose={() => setReport(null)} onSaveSubmission={handleUpdateReportData} triggerModal={triggerModal} />}

{/* 🌟 GLOBAL ONAY PENCERESİ 🌟 */}
      <ConfirmModal 
        {...globalModal} 
        onCancel={closeGlobalModal} 
        onConfirm={() => {
          if (globalModal.onConfirm) globalModal.onConfirm();
          else closeGlobalModal();
        }} 
      />
    </div>
  ); 
};


export default App;